import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import WorkflowStepper from "../../../components/common/workflow-stepper/WorkflowStepper";
import "./CampaignCreationSteps.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const CampaignCreationSteps = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const userRole = useSelector((state) => state.login.userType);
  const getCurrentStep = () => {
    const { pathname, search } = location;
    const params = new URLSearchParams(search);
    if (pathname === "/buyer/campaign-payment" && params.get("step") === "1") {
      return 3;
    }
    if (
      pathname === "/buyer/messages" ||
      pathname === "/buyer/campaign-payment"
    ) {
      return 2;
    }
    if (
      pathname === "/buyer/mycampaigns" ||
      pathname === "/buyer/campaigndetails" ||
      pathname === "/buyer/viewcart"
    ) {
      return 1;
    }
    if (
      pathname === "/products" ||
      pathname === "/productsdetails" ||
      pathname === "/buyer/products" ||
      pathname === "/buyer/productsdetails"
    ) {
      return 0;
    }

    return 0;
  };

  const currentStep = getCurrentStep();
  const redirectToLogin = (targetPath) => {
    sessionStorage.setItem("campaignPostLoginRedirect", targetPath);
    navigate("/login");
  };
  const getStep3Path = () => {
    const params = new URLSearchParams(location.search);
    const campaignId = params.get("campaignId");
    if (campaignId) {
      return `/buyer/campaign-payment?campaignId=${encodeURIComponent(
        campaignId,
      )}&step=1`;
    }
    return "/buyer/campaign-payment?step=1";
  };
  const handleStepChange = (step) => {
    let targetPath = "";
    switch (step) {
      case 0:
        if (isLoggedIn && userRole === "basic") {
          targetPath = "/buyer/products?page=1";
        } else {
          targetPath = "/products?page=1";
        }
        navigate(targetPath);
        break;
      case 1:
        targetPath = "/buyer/mycampaigns?segment=saved_campaign";
        if (!isLoggedIn) {
          redirectToLogin(targetPath);
          return;
        }
        navigate(targetPath);
        break;
      case 2:
        targetPath = "/buyer/messages";
        if (!isLoggedIn) {
          redirectToLogin(targetPath);
          return;
        }
        navigate(targetPath);
        break;

      case 3:
        targetPath = getStep3Path();
        if (!isLoggedIn) {
          redirectToLogin(targetPath);
          return;
        }
        navigate(targetPath);
        break;
      default:
        break;
    }
  };

  const getTitle = (title) => (
    <span className="campaign-step-title">
      {title} <InfoCircleOutlined className="campaign-step-info-icon" />
    </span>
  );
  const steps = [
    {
      title: getTitle("Search Assets & add to Campaigns"),
    },
    {
      title: getTitle("Review Campaigns & add to Cart"),
    },
    {
      title: getTitle("Negotiate with Sellers"),
    },
    {
      title: getTitle("Process Insertion Order (Purchase)"),
    },
  ];

  return (
    <WorkflowStepper
      items={steps}
      currentStep={currentStep}
      onChange={handleStepChange}
      className="campaign-creation-stepper"
    />
  );
};

export default CampaignCreationSteps;
